
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/(ocelot)/video/show/[...id]",
      function () {
        return require("private-next-pages/(ocelot)/video/show/[...id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/(ocelot)/video/show/[...id]"])
      });
    }
  